import React, { Component } from "react";

import Checkbox from "@material-ui/core/Checkbox";
import LinearProgress from '@material-ui/core/LinearProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

export default class ClientLanguageSection extends Component {

  handleToggle = (e) => {
    console.log('check', e);
  }

  render() {

    return (
      <React.Fragment>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 50
          }}
        >
          <Typography component="span" variant="h6" color="inherit">
            Languages
          </Typography>
        </div>
        
            {this.props.disabled && (
              <LinearProgress
                color="primary"
                style={{ height: 2, marginTop: 20 }}
              />
            )}
            <Paper
              style={
                this.props.disabled
                  ? { padding: "6px 0" }
                  : { padding: "6px 0", marginTop: 20 }
              }
            >
              {/* <List>
                {this.props.data.map((item, i) => {
                  return (
                    <ListItem key={item}>
                      <ListItemText primary={`${i + 1}. ${item}`} />
                      {this.props.presentation ? null : (
                        <ListItemSecondaryAction>
                          {this.props.edit ? (
                            <IconButton disabled={this.props.disabled}>
                              <DeleteIcon
                                onClick={() =>
                                  this.props.deleteLanguage(item)
                                }
                              />
                            </IconButton>
                          ) : (
                            <IconButton disabled={this.props.disabled}>
                              <CloseIcon
                                onClick={() =>
                                  this.props.removeItem("languages", i)
                                }
                              />
                            </IconButton>
                          )}
                        </ListItemSecondaryAction>
                      )}
                    </ListItem>
                  );
                })}
              </List> */}
              <List>
              {['English', 'French', 'Mandarin', 'Cantonese', 'Punjabi'].map((item, i) => {
                  const labelId = `checkbox-list-secondary-label-${item}`;
                  return (
                    <ListItem key={i} button>
                      <ListItemText id={labelId} primary={item} />
                      <ListItemSecondaryAction>
                        <Checkbox
                          edge="end"
                          checked={this.props.data.indexOf(item) !== -1}
                          onChange={() => this.props.handleToggle(item, i)}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}
              </List>
            </Paper>
      </React.Fragment>
    );
  }
}
